// Temporary, frontend-only feature toggles. These do not call any backend
// endpoint or touch permissions — they only gate what the UI renders, so a
// feature can be pulled without deleting or restructuring any component.
// Flip a flag back to `true` to re-enable that feature; no other code
// changes are needed.
export const FEATURE_FLAGS = {
  // Hides the ENTIRE booking UI — every booking entry point is removed rather
  // than shown as "unavailable":
  //   - member/coach portals: the "Book Facility"/"Booking" sidebar tab, the
  //     "Book a Facility" quick actions, and every facility card/button that
  //     leads into the availability/booking flow (MemberDashboard.jsx,
  //     CoachDashboard.jsx)
  //   - admin: the "Bookings" and "Booking Logs" ADMIN_NAV entries — both the
  //     sidebar links and their /admin/* routes (adminNav.js) — plus the
  //     "View Bookings" quick action on AdminDashboard.jsx
  //   - public home page: the "Book a Facility"/"Book now" buttons
  // All booking code, services and backend APIs are left untouched.
  bookingUI: true,

  // Public, self-service club registration. While false, the "Club
  // Registration" option on /select-registration only shows a popup telling
  // the user to register through a System User, and /club-registration (plus
  // the legacy /clubregister) redirects away — ClubRegistration.jsx and all
  // admin/System User club registration flows are untouched. Flip back to
  // `true` to restore the public club registration form.
  publicClubRegistration: false,

  // Facility booking creation — member self-booking (MemberDashboard.jsx /
  // CoachDashboard.jsx "book"/"bookings" tabs) and staff booking-on-behalf-of
  // a member (BookingsManagement.jsx "Book for Member" tab). Viewing existing
  // bookings/booking logs is unaffected — only creating a *new* booking is
  // gated by this flag. Only relevant while `bookingUI` is true.
  facilityBooking: false,
};
